export { default } from './Logo'



// WEBPACK FOOTER //
// ./src/modules/common/components/logo/index.js